module.exports = __webpack_public_path__ + "img/01.e9d50726.png";